<script
  setup
  lang="ts"
  generic="
    T extends ApiUrls<any, FUNCTION>,
    FUNCTION extends (data: K[], query?: unknown) => unknown,
    K extends TableStats<L>,
    L extends Record<string, string | number>,
    J
  "
>
import { ApiUrls } from '../../types/base'
import { TableStats } from '../../types/stats'
import { PejerGraphProviderOptions, usePejerGraphProvider } from '../../usePejerGraphProvider'

// type EndpointResponseItem = EndpointResponse<T>[number]

const props = defineProps<PejerGraphProviderOptions<T, K, L, J>>()

// const query = computed(() =>
//   props.query ? getQueryStringFromFiltersObject(unref(props.query)) : ''
// )

// const fromDate = computed(() =>
//   props.fromDate ? unref(props.fromDate)?.toISOString().slice(0, 10) : undefined
// )
// const toDate = computed(() =>
//   props.toDate ? unref(props.toDate)?.toISOString().slice(0, 10) : undefined
// )

// const { data, dataState } = usePejerQuery<T, EndpointResponseItem[]>(props.url, {
//   queryKey: [props.url, query, props.groupBy, fromDate, toDate],
//   body: {
//     filters: query,
//     groupBy: props.groupBy,
//     fromDate: fromDate,
//     toDate: toDate,
//   },
//   select: (data) => data.sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime()),
// })
const { data, dataState } = usePejerGraphProvider<T, K, L, J>(props)
</script>
<template>
  <slot :="{ data, dataState }" />
</template>
